<template>
    <div class="page-admin page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">组织部门管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
                            <el-breadcrumb-item>组织部门管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleAdmin('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <!-- <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button> -->
                </el-col>
            </el-row>
            <div class="bd">
                <!-- <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="姓名：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="输入姓名" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="mobile" label="手机号：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.mobile" size="small" placeholder="输入手机号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div> -->
                <div class="table-block content-body">
                    <div ref="contentBody">
						 <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" row-key="icode" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @selection-change="handleSelectionChange">
                           <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                            <!-- <el-table-column prop="icode" width="80" label="ID" align="center"></el-table-column> -->
							<el-table-column prop="name" align="center" label="组织名称" min-width="120">
							</el-table-column>
                            <el-table-column prop="icon" align="center" label="组织图标" min-width="160">
                                <template slot-scope="scope">
									
                                    <img class="cursor" :src="baseUrl+'/api/sys/file/download?attachId=' + scope.row.icon+'&width=300'" height="50" @click="dlg_preview.img_url = baseUrl + '/api/sys/file/download?attachId='+scope.row.icon+'&width=300';dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
                            
                            <el-table-column prop="fullName" align="center" label="组织全称" min-width="120">
                            </el-table-column>
							<el-table-column prop="address" align="center" label="地址" min-width="120">
							</el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="300" fixed="right">
                                <template slot-scope="scope">
                                   <!-- <el-button class="option-btn btn-bd-o" type="primary" size="mini" @click="settingAuth('menu',scope.row.id,scope.row.username)">菜单权限</el-button>
                                    <el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="settingAuth('option',scope.row.id,scope.row.username)">操作权限</el-button> -->
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleAdmin('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteAdmin(scope.row.icode)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                   <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export admin-dialog" :title="dlg_admin.title" :visible.sync="dlg_admin.visible" width="534px" @close="closeAdmin" :close-on-click-modal="false">
            <el-form ref="formAdmin" :model="dlg_admin.form" label-width="120px" :rules="dlg_admin.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="组织名称：" :error="dlg_admin.error.name">
                    <el-input size="small" v-model="dlg_admin.form.name" placeholder='请输入组织名称' :disabled="dlg_admin.name_disabled" clearable></el-input>
                </el-form-item>
				<el-form-item  prop="parentId" label="父级组织：">
				    <el-select style="width: 270px;" v-model="dlg_admin.form.parentId" placeholder="请选择" @change="(val) => checkChange(val)">
				        <el-option
				                v-for="item in dlg_admin.init_data.parent_list"
				                :key="item.icode"
				                :label="item.fullName"
				                :value="item.icode">
				        </el-option>
				    </el-select>
					(不选默认顶级)
				</el-form-item>
				<el-form-item prop="shortName" style="margin-top: 15px;" label="组织简称：" :error="dlg_admin.error.shortName">
				    <el-input size="small" v-model="dlg_admin.form.shortName" placeholder='请输入用户名' clearable></el-input>
				</el-form-item>
				<el-form-item prop="fullName" style="margin-top: 15px;" label="组织全称：" :error="dlg_admin.error.fullName">
				    <el-input size="small" v-model="dlg_admin.form.fullName" placeholder='请输入用户名' clearable></el-input>
				</el-form-item>
				<el-form-item prop="address" style="margin-top: 15px;" label="地址：" :error="dlg_admin.error.address">
				    <el-input size="small" v-model="dlg_admin.form.address" placeholder='请输入用户名' clearable></el-input>
				</el-form-item>
				<el-form-item prop="showOrder" label="排序：">
				<el-input size="small" type='number' v-model="dlg_admin.form.showOrder" placeholder='请输入排序（输入数字）' clearable></el-input>
				</el-form-item>                 
               <!-- <el-form-item  prop="role_ids" label="设置角色：" :error="dlg_admin.error.role_ids">
                    <el-select size="small" v-model="dlg_admin.role_ids" multiple placeholder="请选择" style="width: 100%;" @change="changeSelect">
                        <el-option
                                v-for="item in dlg_admin.init_data.role_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
				
                <el-form-item prop="icon" label="设置头像：">
                    <el-upload
                            :action="dlg_admin.params.action"
                            :headers="dlg_admin.params.headers"
                            :data="dlg_admin.params.data"
                            accept="image/png,image/jpeg,image/jpg"
                            :class="dlg_admin.hide_upload?'hide-upload head-upload':'head-upload'"
                            list-type="picture-card"
                            :file-list="dlg_admin.img_list"
                            name="file"
                            :on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
                            :on-remove="removeImg"
                            :on-success="uploadSuccessImg">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <!--<p class="tips">（添加到视频上的水印尺寸与实际上传的图片尺寸保持一致）</p>-->
                </el-form-item>
				<el-form-item prop="isDelete" label="逻辑删除：">
				     <el-radio-group v-model="dlg_admin.form.isDelete">
				         <el-radio v-for="(item, index) in dlg_admin.init_data.isDelete_list" :key="index" :label="item.id">{{item.name}}</el-radio>
				     </el-radio-group>
				 </el-form-item>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_admin.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitAdmin()" :loading="dlg_admin.btn_loading">确认</el-button>
            </span>
        </el-dialog>

        <el-drawer :title="dlg_drawer.title" :visible.sync="dlg_drawer.visible" :modal-append-to-body="true" @close="closeDrawer" :show-close="true" size="320px">
            <div style="padding: 10px 20px;">
                <el-form :inline="true" ref="formAuth" :model="dlg_drawer.form" class="demo-form-inline" @submit.native.prevent>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;margin-left: 8px;">
                                <el-checkbox v-model="dlg_drawer.form.allchecked" @change="getAllAuth"/> 全选/取消
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <el-form-item style="margin-right: 0;margin-bottom: 0;">
                                <!--<el-button type="primary" class="btn-bg-p" style="height: 32px;padding: 8px 15px;;"  size="small" @click='getAllAuth()'>全选</el-button>-->
                                <el-button type="primary" class="btn-bg-p" style="height: 32px;padding: 8px 15px;;"  size="small" @click='saveAuth()' :loading="dlg_drawer.btn_loading">保存</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-tree
                        :data="dlg_drawer.data"
                        show-checkbox
                        node-key="id"
                        ref="authtree"
                        :default-expand-all="true"
                        :default-checked-keys="dlg_drawer.default_list"
                        :check-on-click-node="true"
                        :props="dlg_drawer.defaultProps">
                </el-tree>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    import CryptoJS from 'crypto-js'
    export default {
        name: 'usercenter',
        data() {
            return {
                drawer: false,
                clientHeight:'',
                body_loading:false,
                is_refresh:true,
                //搜索
                form_search:{
                    //id: "",
                    //username:'',
                    name:'',
                    mobile:'',
                    status: -1
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'},{id:1, name: '开启'},{id:2, name: '禁用'}],
					
                },
                baseUrl:this.$client.IMG_URL,
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_admin:{
                    id:'',
                    title:'',
                    type:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    username_disabled:false,
                    hide_upload: false,
                    img_list: [],
                    r_password:"",
                    role_ids:[1],
                    form:{
						icode:'',
                        name:"",
                        shortName:'',
						fullName:'',
						address:'',
                        showOrder:0,
                        icon:'',
						isDelete:0,
						parentId:0,
                    },
                    error:{
                        name:"",
                        shortName:"",
                        fullName:'',
                        address:'',
                        parentId:'',
                        status:'',
                        icon:''
                    },
                    reset_form: {},
                    init_data:{
                        role_list:[],
						parent_list:[],
						supplier_list:[],
                        status_list: [],
						isDelete_list:[{id:0, name: '否'},{id:1, name: '是'}]
                    },
                    params:{
                        action: this.$client.API_URL+'/api/sys/file/upload',
                        data:{path:'admin'},
                        headers:{token:localStorage.getItem('token'),loginFrom:'pc'}
                    },
                    rules:{
                        name:{required: true, message: '请输入组织名称', trigger: ['change','blur']},
                        fullName:{required: true, message: '请输入组织全称', trigger: ['change','blur']},
                        shortName:{required: true, message: '请输入组织简称', trigger: ['change','blur']},
                        parentId:{required: false, message: '请选择父级组织', trigger: ['change','blur']},
                        showOrder:{required: true, message: '请输入排序', trigger: ['change','blur']},
						isDelete:{required: true, message: '请选择是否逻辑删除', trigger: ['change','blur']},
                    }
                },
                dlg_drawer:{
                    title:'权限设置',
                    visible: false,
                    btn_loading:false,
                    id:'',
                    type:'',
                    api: '',
                    form:{
                        allchecked:false,
                        menu_ids:[],
                        operate_ids:[]
                    },
                    default_list:[4,5],
                    data: [],
                    defaultProps: {
                        children: 'children',
                        label: 'name'
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '管理员管理';
            this.dlg_admin.reset_form = Object.assign({}, this.dlg_admin.form);
            this.getList();
			this.getDeptList();
        },
        methods: {
			//选中的父级组织
			checkChange(val){
				console.log(val);//选中的值
				console.log(val,"fashi")
				// this.dlg_power.init_data.power_list.forEach((item)=>{
				// 	if(item.powerKey==val){
				// 		this.dlg_power.form.name=item.name,
				// 		this.dlg_power.form.icode=item.icode
				// 	}
				// })
										
									
			   // console.log(row);//自定义的参数
			},
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
			getDeptList(){
				var _this = this;
				   _this.table_data.loading = true;
					var parent_list = [];
				   this.$client.get('/api/sys/org/getListForAdmin', {}, function(res,message){
						_this.dlg_admin.init_data.parent_list = parent_list.concat(res);
					   _this.table_data.loading = false;
				   },function(res){
					   _this.table_data.loading = false;
				   });
			},
            getList() {
                var _this = this;
                
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
				var desk_list = [{number:'', name: '不关联'}];
				var supplier_list = [{number:'', name: '不关联'}];
                this.$client.get('/api/sys/org/getTreeForAdmin', {}, function(res,message,total,totalPages){
                    _this.table_data.list = res;
     //                _this.init_data.status_list = status_list.concat(res.status_name_list);
					// _this.dlg_admin.init_data.desk_list = desk_list.concat(res.desk_name_list);
					// _this.dlg_admin.init_data.supplier_list = supplier_list.concat(res.supplier_name_list);
     //                _this.dlg_admin.init_data.status_list = res.status_name_list;
     //                _this.dlg_admin.init_data.role_list = res.role_name_list;
                    // _this.table_data.page_info = res.pager;
					// _this.table_data.page_info.page = totalPages;
					 _this.table_data.page_info.total=total
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的管理员");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/admin/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            handleAdmin(type,data){
                this.dlg_admin.visible = true;
                this.dlg_admin.type = type;
                if(type == 'add'){
                    this.dlg_admin.title = '添加管理部门';
                    this.dlg_admin.api = '/api/sys/org/save';
                    this.dlg_admin.name_disabled = false;
                }else{
                    this.dlg_admin.icode= data.icode;
                    this.dlg_admin.title = '编辑管理部门';
                    this.dlg_admin.name = true;
					this.dlg_admin.form.icode= data.icode;
                    this.dlg_admin.form.name = data.name;
                    this.dlg_admin.shortName = data.shortName;
                    this.dlg_admin.form.fullName = data.fullName;
                    this.dlg_admin.form.address = data.address;
					this.dlg_admin.form.parentId = data.parentId;
					// if(data.parentId=='0'){
					// 	this.dlg_admin.form.parentId='顶级'
					// }
                    this.dlg_admin.form.icon = data.icon;
					 this.dlg_admin.form.showOrder = data.showOrder;
					
                    if(data.icon){
					//	`${config.baseUrl}api/os/sys/file/download?attachId=${row.img_ids}&width=200`
					console.log(this.baseUrl,"this.baseUrl")
                        this.dlg_admin.img_list = [{name: data.name, url: this.baseUrl +'/api/sys/file/download?attachId='+ data.icon+'&width=200'}];
						console.log(this.dlg_admin.img_list,"this.dlg_admin.img_list")
                        this.dlg_admin.hide_upload = true;
                    }else{
                        this.dlg_admin.img_list = [];
                        this.dlg_admin.hide_upload = false;
                    }
                    this.dlg_admin.api = '/api/sys/org/save';
                }
            },
            deleteAdmin(icode){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/api/sys/org/delete', {id:icode}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            getInitData(id,type){
                var _this = this;
                this.$client.get('/adminapi/admin/getdata', {id:id}, function(data,msg){;
                    if(type=='menu'){
                        _this.dlg_drawer.data = data.menu_list;
                        _this.dlg_drawer.default_list = data.menu_auth_list;
                    }else if(type=='option'){
                        _this.dlg_drawer.data = data.operate_list;
                        _this.dlg_drawer.default_list = data.operate_auth_list;
                    }
                    _this.body_loading = false;
                }, function(msg){
                    _this.body_loading = false;
                });
            },
            settingAuth(type,id,username){
                this.getInitData(id,type);
                this.dlg_drawer.id = id;
                this.dlg_drawer.type = type;
                if(type=='menu'){
                    this.dlg_drawer.title = username+' - 菜单权限设置';
                    this.dlg_drawer.api = '/adminapi/admin/setmenuauth';
                }else if(type == 'option'){
                    this.dlg_drawer.title = username+' - 操作权限设置';
                    this.dlg_drawer.api = '/adminapi/admin/setoperateauth';
                }
                this.dlg_drawer.visible = true;
            },
            uploadSuccessImg(res, file, fileList){
                this.dlg_admin.img_list = fileList;
                this.dlg_admin.form.icon = res.data.icode;
				console.log(res.data,"数据")
                this.dlg_admin.hide_upload = true;
            },
            removeImg(file, fileList){
                this.dlg_admin.form.head_portrait = '';
                this.dlg_admin.img_list = [];
                this.dlg_admin.hide_upload = false;
            },
            getAllAuth(){
                if (this.dlg_drawer.form.allchecked) {
                    //全选
                    this.$refs.authtree.setCheckedNodes(this.dlg_drawer.data);
                }else{
                    //取消选中
                    this.$refs.authtree.setCheckedNodes([]);
                    this.$refs.authtree.setCheckedKeys(this.dlg_drawer.default_list);
                }
            },
            saveAuth(){
                var _this = this;
                //console.log(this.$refs.authtree.getCheckedKeys(true));
                //console.log(this.$util.getCheckedKeys(this.dlg_drawer.data, this.$refs.authtree.getCheckedKeys(), 'id'));
                var params;
                if(this.dlg_drawer.type=='menu'){
                    var menu_arr = this.$util.getCheckedKeys(this.dlg_drawer.data, this.$refs.authtree.getCheckedKeys(), 'id');
                    this.dlg_drawer.form.menu_ids = menu_arr.join(",");
                    params = {id:this.dlg_drawer.id,menu_ids:this.dlg_drawer.form.menu_ids}
                }else if(this.dlg_drawer.type=='option'){
                    var operate_arr = this.$util.getCheckedKeys(this.dlg_drawer.data, this.$refs.authtree.getCheckedKeys(), 'id');
                    this.dlg_drawer.form.operate_ids = operate_arr.join(",");
                    params = {id:this.dlg_drawer.id,operate_ids:this.dlg_drawer.form.operate_ids}
                }
                _this.dlg_drawer.btn_loading = true;
                this.$client.post(this.dlg_drawer.api, params, function(res,message){
                    //console.log(res)
                    _this.$message(message);
                    _this.getList();
                    _this.dlg_drawer.btn_loading = false;
                    _this.dlg_drawer.visible = false;
                }, function(message){
                    //console.log(message);
                    _this.dlg_drawer.btn_loading = false;
                    if((typeof message)==='object'){
                        for(var key in message){
                            _this.dlg_admin.error[key] = message[key];
                        }
                    }
                });
            },
            closeDrawer(){
                this.dlg_drawer.default_list = [];
                this.$refs.authtree.setCheckedNodes([]);
            },
            changeSelect(val){
                console.log(val.toString());
                this.dlg_admin.form.role_ids = val.toString();
            },
            submitAdmin(){
                var _this = this;
               
                /*this.dlg_admin.form.head_portrait = this.dlg_admin.img_list.url;*/
                //this.dlg_admin.form.role_ids = this.dlg_admin.role_ids.toString();
                _this.$refs['formAdmin'].validate((valid) => {
                    if (valid) {
                        this.dlg_admin.btn_loading = true;
                        this.$client.post(this.dlg_admin.api, this.dlg_admin.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_admin.btn_loading = false;
                            _this.dlg_admin.visible = false;
                        }, function(message){
                            console.log(message);
                            _this.dlg_admin.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_admin.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeAdmin(){
                this.dlg_admin.role_ids = [1];
                this.dlg_admin.r_password = '';
                this.dlg_admin.img_list = [];
                this.dlg_admin.hide_upload = false;
                for(var key in this.dlg_admin.form){
                    this.dlg_admin.form[key] = this.dlg_admin.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formAdmin.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .el-drawer__header{
        margin-bottom: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #e9e9e9;
    }
    .el-drawer,.el-drawer__header,.el-drawer__header>:first-child{
        outline: none !important;
    }
    .page-admin .el-upload--picture-card{
        line-height: 80px;
    }
    .page-admin .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }

    .domain-dialog .el-form-item__label:before,.forward-dialog .el-form-item__label:before{
        display: none;
    }
    .approve-dialog .el-dialog__footer{
        text-align: center;
    }
    .error-dialog .el-dialog__header{
        border-bottom: none;
        padding-top: 25px;
        text-align: center;
    }
    .page-admin .el-drawer__body{
        height: calc(100% - 67px) !important;
    }
    .page-admin .el-drawer__body>div{
        height: 100% !important;
        box-sizing: border-box;
        overflow-y: auto !important;
    }
</style>
<style scoped>

</style>